var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fechamento)?_c('recursos-pagina'):_c('legacy-dashboard')
}
var staticRenderFns = []

export { render, staticRenderFns }